import React from 'react';
import {Form, Descriptions, } from 'antd';

export const FormField = ({editable, ...props}) => {

    const defaultDescriptionProps = {
        layout: 'vertical', 
        style: { 
            marginBottom: 24
        }, 
        labelStyle: { 
            fontWeight: 600, 
        }, 
        size: 'small',
        colon: true,
        ...props,
    }

    return (
        <>
            { editable ? 
                <Form.Item {...props}>
                    {props.children}
                </Form.Item>
            : 
                <Descriptions {...defaultDescriptionProps}> 
                    <Descriptions.Item label={props.label}>{props.text || 'N/A'}</Descriptions.Item>
                </Descriptions>
            }
        </>
    )
}

FormField.defaultProps = {
    editable: true,
}